import script from "./m-author-types-btns.vue?vue&type=script&setup=true&lang=js"
export * from "./m-author-types-btns.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__